// extracted by mini-css-extract-plugin
export default {"root":"Dashboard_root__1vGxi","row":"Dashboard_row__gDYkI","section":"Dashboard_section__KK7Px"};